export default __webpack_public_path__ + "a1c731b7a9bf397298446868839a8aa5.svg";